import SalonMatch from 'components/pages/salons/salonMatch';
import { handleGetDistance } from 'lib/utils/salonsHelpers';
import { useMemo } from 'react';
import styles from './matchesList.module.scss';

const MatchesList = ({
  salonsInRadius,
  hovered,
  initialViewport,
  setActive,
  setHovered,
  setShowSalon,
  setSalonFocus,
  resultsLimit,
}) => {
  const salonsWithDistance = useMemo(() => {
    if (salonsInRadius.length > 0) {
      /** Map salons with distance and sort them from closest to furthest */
      const sortedSalonsByDistance = salonsInRadius
        .map(salon => {
          const formattedDistance = (
            handleGetDistance(
              {
                latitude: salon?.position?.latitude,
                longitude: salon?.position?.longitude,
              },
              initialViewport
            ) / 1000
          ).toFixed(1);

          return { ...salon, formattedDistance };
        })
        .sort((salonA, salonB) => salonA.formattedDistance - salonB.formattedDistance);

      const limitedSalons = resultsLimit
        ? sortedSalonsByDistance.slice(0, resultsLimit)
        : sortedSalonsByDistance;

      /** Return closest ambassador or keune salon first, then spread the rest of the salons */
      const closestAmbassadorSalon = limitedSalons.find(
        salon => salon.salonLoyalty || salon.client100
      );
      const otherSalons = limitedSalons.filter(salon => salon !== closestAmbassadorSalon);

      if (closestAmbassadorSalon !== undefined) return [closestAmbassadorSalon, ...otherSalons];
      return otherSalons;
    }

    return [];
  }, [salonsInRadius, initialViewport]);

  return (
    <div className={styles.matchesContainer}>
      {salonsWithDistance.map((salon, index) => (
        <SalonMatch
          key={salon?.salonNo}
          index={index}
          salon={salon}
          hovered={hovered}
          setActive={setActive}
          setHovered={setHovered}
          setShowSalon={setShowSalon}
          setSalonFocus={setSalonFocus}
          formattedDistance={salon.formattedDistance}
        />
      ))}
    </div>
  );
};

export default MatchesList;
